import { NotificationService } from "../services/notification.service";
import { differenceBy } from "lodash";


const service = new NotificationService()

export const state = {
  notificationHistory: []
}

export const mutations = {
  SET_NOTIFICATION_HISTORY(state, notifications) {
    state.notificationHistory = notifications;
  },

  UPDATE_NOTIFICATION_HISTORY(state, { id, notification }) {
    const matchIndex = state.notificationHistory.findIndex(n => n.id == id);
    if(matchIndex > -1) {
      state.notificationHistory.splice(matchIndex, 1, notification);
    }
  },
  DELETE_NOTIFICATIONS(state, ids) {
    const result = differenceBy(state.notificationHistory.notifications, ids.map(id => ({ id })), 'id');
    state.notificationHistory.notifications = result;
  }
}

export const actions = {
  async loadNotifications({ commit }, { userId, appName }) {
    const { data } = await service.loadUserNotificationHistroy(userId, appName);
    commit('SET_NOTIFICATION_HISTORY', data);
  },

  async addNotification({ dispatch }, { recieverID, module, ...notification }) {
    await service.addUserNotification(recieverID, module, notification);
  },

  async deleteNotifications({ commit }, { userId, ids}) {
    await service.deleteNotifications(userId, ids);
    commit('DELETE_NOTIFICATIONS', ids)
  },

  markAsRead({ commit }, { id, notification }) {
    commit('UPDATE_NOTIFICATION_HISTORY', { id, notification });
  }
}